import React from "react";
import { useButtonsActions } from "../../hooks/useButtonsActions";
import { useModalTicket } from "../../hooks/useModalTicket";
import "./styles.scss";

interface FixedButtonProps {}

function FixedButton({}: FixedButtonProps) {
  const { handleNavigateToPages } = useButtonsActions();
  const {toggleModal} = useModalTicket()

  return (
    <div className="flex fixedButton">
      <div className="col">
        <button onClick={handleNavigateToPages} className="storesButton">
          VER LOJAS
        </button>
      </div>
      <div className="col">
        <button onClick={toggleModal} className="ticketButton">
          Envie seu boleto
        </button>
      </div>
    </div>
  );
}

export { FixedButton };
